import { Injectable } from '@angular/core';
import { CfgService } from '../../cfg/cfg.service';
import { HttpBackend } from '@angular/common/http';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class ImpersonationCfg {
  public officeTeamEndpoint: string;
  public impersonationEnabledResourceId: number;
}

@Injectable({
  providedIn: 'root'
})
export class ImpersonationCfgService extends CfgService<ImpersonationCfg> {
  json: any = {
    officeTeamEndpoint: "%{DashboardApiUrl}/office/{0}/team",
    impersonationEnabledResourceId: 1693
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/impersonation.cfg.json`;
  }

  /**
* Carga las url en el json
*/
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
